import { css, cx } from "@emotion/css";
import { find } from "lodash";
import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { BreakLesson } from "src/components/Course/lessons/Lesson/BreakLesson";
import { ChallengeLesson } from "src/components/Course/lessons/Lesson/ChallengeLesson";
import { ExamLesson } from "src/components/Course/lessons/Lesson/ExamLesson";
import { RepetitionLesson } from "src/components/Course/lessons/Lesson/RepetitionLesson";
import { IconButton } from "src/components/Default/LekUI/Button";
import { htmlFormatter } from "src/formatters/htmlFormatter";
import ArrowPrevIcon from "src/images/Icons/newIcons/controllers/arrowPrev.svg";

const LessonViewItems: Record<string, React.ComponentType<any>> = {
	exam: ExamLesson,
	break: BreakLesson,
	repetition: RepetitionLesson,
	challenge: ChallengeLesson,
};

interface LessonsListProps {
	section: any;
	className?: string;
	folders?: any[];
}

export const LessonsList = ({ section, className, folders = [] }: LessonsListProps) => {
	const listRef = useRef<HTMLDivElement>(null);
	const history = useHistory();

	useEffect(() => {
		if (listRef.current) {
			listRef.current.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		}
	}, []);

	// Wszystkie lekcje poza powtórką/wyzwaniem są od razu waiting — aktywna to rozpoczęta, a jak brak, pierwsza nierozpoczęta
	const activeLesson =
		find(section.lessons, { status: "incomplete" }) ||
		find(section.lessons, { status: "waiting" });

	return (
		<div
			className={cx(
				className,
				"basic-container lessons-view",
				css`
          scroll-margin-top: 100px;
        `,
			)}
			ref={listRef}
		>
			<div className="flex flex-col gap-4">
				<div className="flex flex-col gap-8">
					<div className="flex items-center gap-8">
						<IconButton
							onClick={() => history.push("/")}
							className="lessons-view--back-button"
						>
							<ArrowPrevIcon className="icon-small" />
						</IconButton>
						<h5 className="m-0 size-20 first-letter-upper">{section.name}</h5>
					</div>
					<p className="size-16-light text-grey m-0">
						{htmlFormatter(section.description)}
					</p>
				</div>
			</div>
			<ul className="lessons-view--list">
				{section.lessons.map((item: any) => {
					const LessonView = LessonViewItems[item.type];
					const className =
						activeLesson?.id === item.id ? "border-medium-primary" : "";
					if (!LessonView) {
						return null;
					}

					return (
						<LessonView key={item.id} lesson={item} className={className} folders={folders} />
					);
				})}
			</ul>
		</div>
	);
};
